module.exports = __webpack_public_path__ + "static/media/flexiKulcs_appbarLogo.d7774a5d.svg";